import { FilterMetadata } from "../../types";
import { useDebouncedState } from "~/utils/useDebouncedInput";
import { SearchIcon } from "lucide-react";
import { Input } from "~/components/ui/input";
import { cn } from "~/lib/utils";

// // // //

export function SearchValueInput(props: {
    value: string;
    filterMeta: FilterMetadata;
    onChange: (updatedValue: string) => void;
    disabled?: boolean;
    className?: string;
}) {
    const { filterMeta, className, disabled } = props;

    const [value, onChange] = useDebouncedState<string>({
        debounceTimeout: 800,
        value: props.value,
        onChange: props.onChange,
    });

    return (
        <div className="relative rounded-full shadow-xs select-none">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <SearchIcon className="text-slate-500 h-4 w-4" />
            </div>
            <Input
                // type="search"
                className={cn("pl-9", className)}
                disabled={disabled}
                value={value}
                placeholder={filterMeta.content.label}
                onChange={(e) => {
                    const updatedValue = e.currentTarget.value;
                    onChange(updatedValue);
                }}
            />
        </div>
    );
}
